import { API_BASE_URL } from "../config/apiBaseUrl";

const ADMIN_BASE = "/api/admin/automotive";
const PUBLIC_BASE = "/api/v1/automap/analytics";

function authHeaders() {
  return { credentials: "include" };
}

export async function ingestBuyerAnalyticsEvent(event) {
  return fetch(`${API_BASE_URL}${PUBLIC_BASE}/events`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ event }),
  }).then((res) => (res.ok ? res.json() : null));
}

export async function fetchBuyerAnalyticsSummary(range = "last_30_days") {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/analytics/buyers?range=${encodeURIComponent(range)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar analytics de compradores.");
  return res.json();
}

export async function fetchFunnelAnalytics(funnel = "homepage_search", range = "last_30_days") {
  const qs = new URLSearchParams({ funnel, range }).toString();
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/analytics/funnels?${qs}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar embudos.");
  return res.json();
}

export async function fetchSearchAnalytics(range = "last_30_days") {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/analytics/search?range=${encodeURIComponent(range)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar analytics de búsqueda.");
  return res.json();
}

export async function fetchQuizAnalytics(range = "last_30_days") {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/analytics/quiz?range=${encodeURIComponent(range)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar analytics del quiz.");
  return res.json();
}

export async function fetchLeadAnalytics(range = "last_30_days") {
  const res = await fetch(`${API_BASE_URL}${ADMIN_BASE}/analytics/leads?range=${encodeURIComponent(range)}`, authHeaders());
  if (!res.ok) throw new Error("No se pudo cargar analytics de leads.");
  return res.json();
}

export async function fetchSellerIntakeAnalytics(range = "last_30_days") {
  const res = await fetch(
    `${API_BASE_URL}${ADMIN_BASE}/analytics/seller-intake?range=${encodeURIComponent(range)}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar analytics de vendedores.");
  return res.json();
}

export async function fetchDealerBuyerAnalytics(dealerId, range = "last_30_days") {
  const qs = new URLSearchParams({ range }).toString();
  const res = await fetch(
    `${API_BASE_URL}/api/v1/automap/dealer-portal/${encodeURIComponent(dealerId)}/analytics/buyers?${qs}`,
    authHeaders()
  );
  if (!res.ok) throw new Error("No se pudo cargar analytics de compradores.");
  return res.json();
}
